module.exports = __webpack_public_path__ + "static/media/time.e7cc4d4d.svg";